module.exports = __webpack_public_path__ + "static/media/magnifier.2737da85.svg";